import styled from 'styled-components';
import { motion } from 'framer-motion';

export const CategoriasContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 20px;

  user-select: none;
`;

export const CardCategoria = styled(motion.div)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;

  width: 120px;
  padding: 2rem 0.5rem;

  background-color: ${({ selected }) => selected ? 'var(--orange-bg)' : 'var(--gray-bg)'};
  
  border-radius: 15px;
  cursor: pointer;

  h2 {
    font-size: 1rem;
    text-transform: capitalize;
    text-align: center;
  }

  :first-child {
    img {
      padding-top: 7px;
      padding-bottom: 7px;
    }
  }
`;

export const BorderDecoration = styled.div`
  height: 5px;
  width: 30%;
  background: var(--btn-gradient);
  border-radius: 15px;
`;
